module.exports = __webpack_public_path__ + "static/img/defult.e6cf1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/prize/defult.png
// module id = 3MdC
// module chunks = 1